import { render, staticRenderFns } from "./DepartmentSelectM.vue?vue&type=template&id=2f1effba&scoped=true&"
import script from "./DepartmentSelectM.vue?vue&type=script&lang=ts&"
export * from "./DepartmentSelectM.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentSelectM.vue?vue&type=style&index=0&id=2f1effba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1effba",
  null
  
)

export default component.exports